import { type FC, useEffect, useState } from "react";
import EN from "@/constants/en";

const HeroBackground: FC = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const logos = EN.TECHNOLOGIES_LIST;

    const [logoPositions, setLogoPositions] = useState<
        Array<{
            x: number;
            y: number;
            size: number;
            rotation: number;
            animationDuration: number;
            animationType: number;
        }>
    >([]);

    useEffect(() => {
        // Delay loading background images to not interfere with LCP
        const loadTimer = setTimeout(() => {
            // Generate random positions for logos
            const positions = logos.map(() => ({
                x: Math.random() * 80 + 10, // 10% to 90% of the width
                y: Math.random() * 80 + 10, // 10% to 90% of the height
                size: Math.random() * 40 + 40, // 40px to 80px
                rotation: Math.random() * 20 - 10, // -10deg to 10deg
                animationDuration: Math.random() * 10 + 15, // 15s to 25s
                animationType: Math.floor(Math.random() * 3), // 0, 1, or 2 for different animation types
            }));
            setLogoPositions(positions);
            setIsLoaded(true);
        }, 100); // Small delay to prioritize LCP

        return () => clearTimeout(loadTimer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="absolute inset-0 overflow-hidden">
            {/* Lower blur intensity for better visibility */}
            <div className="absolute inset-0 bg-gradient-to-br from-background/80 to-secondary/30 backdrop-blur-sm z-10" />
            <div className="absolute inset-0">
                {isLoaded && logos.map(
                    (logo, index) =>
                        logoPositions.length > 0 && (
                            <img
                                key={logo.name}
                                src={logo.src}
                                alt={`${logo.name} ${EN.HERO_BG_LOGO_ALT_SUFFIX}`}
                                className="absolute opacity-30 select-none pointer-events-none"
                                loading="lazy"
                                decoding="async"
                                width={logoPositions[index]?.size || 60}
                                height={logoPositions[index]?.size || 60}
                                sizes="80px"
                                style={{
                                    width: `${logoPositions[index]?.size || 60}px`,
                                    height: `${logoPositions[index]?.size || 60}px`,
                                    left: `${logoPositions[index]?.x || 50}%`,
                                    top: `${logoPositions[index]?.y || 50}%`,
                                    transform: `translate(-50%, -50%) rotate(${logoPositions[index]?.rotation || 0}deg)`,
                                    animation: `float-${logoPositions[index]?.animationType || 0} ${
                                        logoPositions[index]?.animationDuration || 20
                                    }s infinite ease-in-out`,
                                    objectFit: "contain",
                                    maxWidth: "80px",
                                    maxHeight: "80px",
                                }}
                                onError={(e) => {
                                    console.error(`${EN.HERO_BG_LOAD_ERROR} ${logo.src}`);
                                    // Hide the image on error
                                    (e.target as HTMLImageElement).style.display = "none";
                                }}
                            />
                        ),
                )}
            </div>
        </div>
    );
};

export default HeroBackground;
